export default __webpack_public_path__ + "static/pic03-b0e33ce9079ac4f485897c0473db2a0d.jpg";